import { action, makeObservable, observable } from "mobx";
import Validator, { ValidatedValue, ValidatorModel } from "./validator";
import { ErrorMessages } from "./errorMessage";
import { clientValidators } from "./clientValidators";
import Formatter, { CapitalizationType } from "./formatter";

export interface NnwBeneficiaryModel {
  fullName: ValidatedValue<string>;
  pesel: ValidatedValue<string>;
  address: ValidatedValue<string>;

  validateNnwBeneficiary: () => void;
}

const nnwBeneficiary: ValidatorModel = {
  fullName: [
    { name: "fullNameIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
    { name: "fullNameIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required }
  ],
  address: [
    { name: "addresssNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
    { name: "addressIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required }
  ]
};

interface NnwBeneficiaryArguments {
  pesel?: string;
  fullName?: string;
  address?: string;
}

export class NnwBeneficiary implements NnwBeneficiaryModel {
  @observable pesel: ValidatedValue<string> = new ValidatedValue("", clientValidators.pesel);
  @observable fullName: ValidatedValue<string> = new ValidatedValue("", nnwBeneficiary.fullName);
  @observable address: ValidatedValue<string> = new ValidatedValue("", nnwBeneficiary.address);

  constructor(args?: NnwBeneficiaryArguments) {
    makeObservable(this);

    this.pesel.value = Formatter.capitalizeWords(args?.pesel?.trim(), CapitalizationType.full) ?? "";
    this.fullName.value = Formatter.capitalizeWords(args?.fullName?.trim(), CapitalizationType.full) ?? "";
    this.address.value = Formatter.capitalizeWords(args?.address?.trim(), CapitalizationType.full) ?? "";
  }

  @action
  public validateNnwBeneficiary() {
    this.fullName.validate();
    this.pesel.validate();
    this.address.validate();
  }
}
